module.exports = __webpack_public_path__ + "img/success-image.9c198084.svg";